import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';

// AI QUESTIONS & ANSWERS
/**
 * In this action creator:
 * - props<{ question:string }>() // props<{ token: string } specifies the shape of the payload that the action will carry.
 * - question // answer is defined as a property of the action’s payload with a specific type (AIQuestion // AIAnswer etc).
 */
// WarmUp to start the AI 
export const WarmUp = createAction(
    '[AI]  GET - warm up action'); 
export const WarmUpSuccess = createAction(
    '[AI]  GET - warm up action Success', props<{ response: Objects.AIAnswer }>());
export const WarmUpFailure = createAction(
    '[AI]  GET - warm up action Failure', props<{ error: HttpErrorResponse }>());

// Send a new question and add it to state
export const SendQuestion = createAction(
    '[AI]  POST - Send a new question', props<{ question: string }>()); // will add in state entries a question type
export const SendQuestionSuccess = createAction(
    '[AI]  POST - Send a new question Success', props<{ response: Objects.AIQuestionResponse }>()); // will add in state entries an empty answer
export const SendQuestionFailure = createAction(
    '[AI]  POST - Send a new question Failure', props<{ error: HttpErrorResponse }>());

// Fetch answerts to state
export const FetchAnswer = createAction(
    '[AI] - GET question answer', props<{ token: string }>());
export const FetchAnswerSuccess = createAction(
    '[AI] - GET question answer Success', props<{ token: string, response: Objects.AIAnswer }>()); // will update in state entries the answer value
export const FetchAnswerFailure = createAction(
    '[AI] - GET question answer Failure', props<{ token: string, error: HttpErrorResponse }>()); // will update in state entries the answer value failed
